<template>
    <!-- 小型分页 -->
    <el-col class="page" slot="pagination" style="padding-top:10px;">
        <el-pagination 
            style="float:right" 
            class="page_bottom" 
            @current-change="handleSizeChg"
            :current-page="pageNum"
            :page-size='10'
            :pager-count="5"
            layout="total, prev, pager, next"
            :total="totalSize">
        </el-pagination>
    </el-col>
</template>   
<script>
  export default {
    name:'paginaitionSmall',
    props:{
        pageNum:{
            type:Number
        },
        totalSize:{
            type:Number
        },
    },
    data () {
        return{
            value:''
        }
    },
    methods:{
        handleSizeChg(size){
            this.$emit('handleSizeChange',size);
        },
    }
  }
</script>


// WEBPACK FOOTER //
// src/publicComponents/paginaitionSmall.vue